import React, {useEffect, useState} from "react";
import {RequestState} from "./BonusReducer";
import {BonusOffer, CurrencyDefinition, UserBonusView} from "../http/protocol";
import Translator from "../Translator";
import {ButtonSpinner} from "../ui/ButtonSpinner";
import "./BonusPage.scss";
import {connect, useDispatch} from "react-redux";
import {AppState} from "../RootReducer";
import {Link} from "react-router-dom";
import {t} from "../i18n";
import {ConfirmButton} from "../ui/ConfirmButton";
import {getContainer} from "../ioc/IOCSetup";
import {clearRequestState, clearRequestStatusState, fetchBonusInfo, setDisplayTermsForBonusConfigId} from "./BonusActions";
import {formatDate} from "../utils/date";
import UFO from "../assets/cow_ufo.png";
import {setActiveCurrency} from "../user/UserActions";
import {AccountCard} from "../ui/AccountUI";
import {getIconFromProduct} from "./NextBonuses";
import { Modal } from "react-bootstrap";
import { BrandA } from "../ui/buttons/buttons";
import { MenuCloseButton } from "../ui/navigation/Menu";


interface Props {offers : BonusOffer[], claim : (id? : number) => Promise<UserBonusView>, claimOfferStatus? : RequestState, activeCurrency:string, fetchBonusInfo: typeof fetchBonusInfo, setActiveCurrency(cc:string): typeof setActiveCurrency, firstOfferCurrency:string}
export const BonusOffers = ( props : Props) => {
    const [isClosed, setIsClosed] = useState<boolean>(false)
    const dispatch = useDispatch();
    const offer:boolean = !!props.offers.find((bonus : any) => bonus.currency === props.activeCurrency);
    let bonuses:any[] = []
    bonuses = props.offers.filter(o => o.bonusConfig && o.currency == props.activeCurrency).map((o : BonusOffer) => (
            <BonusOfferComponent key={o.id} o={o}  claimOfferStatus={props.claimOfferStatus}  claim={(id? : number) => props.claim && props.claim(id)} fetchBonusInfo={props.fetchBonusInfo}/>
    ));

    const closeError = () => {
        setIsClosed(false)
        dispatch(clearRequestStatusState() as any);
    }

    useEffect(()=>{
        if(props.claimOfferStatus === RequestState.ERROR){
            setIsClosed(true)
        }
    },[props.claimOfferStatus])

    return (
        <>
            <Modal dialogClassName={"action-dialog"} show={isClosed}>
                <Modal.Header>
                    <div className={"menu-close"} onClick={() => closeError()}>
                        <MenuCloseButton />
                    </div>
                </Modal.Header>
                <Modal.Body>
                        <>
                            <h4>{t("rewards.claim-dialog.title-error")}</h4>
                            <p>
                                {t("rewards.claim-dialog.text-error")}
                            </p>
                            <div className={"actions"}>
                                <BrandA className={"btn btn-secondary-popup"} onClick={()=>closeError()}>{t("rewards.claim-dialog.close")}</BrandA>
                            </div>
                        </>
                </Modal.Body>
            </Modal>
            <h3 className={"section"}>{t("bonus.offers")}</h3>
            {bonuses}
            <div className={"row"}>
                <div className={"col-md-4 offset-4 cancel-container"}>
                    {
                        bonuses.length > 1 && (
                            <div className="row cancel-all">
                                <ConfirmButton className={"btn btn-secondary-popup small full-width"}
                                               onConfirm={()=>{
                                                   return getContainer().getUserBonusService().cancelAllBonusOffers().then(() => {
                                                       return props.fetchBonusInfo && props.fetchBonusInfo()
                                                   }) }
                                               }
                                               label={t("bonus.cancel-all-offers.button-label")}
                                               errorText={t("bonus.cancel-all-offers.error-text")}
                                               confirmText={t("bonus.cancel-all-offers.confirm-text")}
                                               confirmTitle={t("bonus.cancel-all-offers.confirm-header")}
                                               customCancelText={t("bonus.cancel-all-offers.custom-cancel-label")}
                                               icon={<i className={"material-icons"}>do_not_disturb_on</i>}
                                />
                            </div>
                        )
                    }
                </div>
            </div>

            <div className={"row notFound-content"}>
                {bonuses.length === 0 && (
                    <div className="notFound-wrapper">
                        <img className={"notFound"} src={UFO} alt={"Not found"}
                             style={{background: `url(${UFO}) no-repeat`, backgroundSize: 'cover'}}/>
                        {props.firstOfferCurrency.length > 0 && (
                            <>
                                <br/>
                                <p>{t("bonus.bonusOfferOther", {currencyCode:props.firstOfferCurrency})}</p>
                                <button onClick={(e) => {
                                    if(typeof props.setActiveCurrency === "function") {
                                        props.setActiveCurrency(props.firstOfferCurrency)
                                    }
                                }} className="btn btn-primary">{t("bonus.switch-button", {currencyCode:props.firstOfferCurrency})}</button>
                            </>
                        )}
                        {
                            props.firstOfferCurrency.length === 0 &&(<p className={"notFound-text"}>{t("bonus.bonusOffersEmpty")}</p>)
                        }
                    </div>
                )}

            </div>
        </>
    )
}


interface BonusOfferProps {
    o : BonusOffer;
    currency? : CurrencyDefinition;
    claimOfferStatus? : RequestState;
    claim : (id? : number) => Promise<UserBonusView>;
    fetchBonusInfo: typeof fetchBonusInfo;
}
const BonusOfferImpl = (props : BonusOfferProps)  => {
    const dispatch = useDispatch();
    const openTerms = () => dispatch(setDisplayTermsForBonusConfigId(o.bonusConfig?.id));

    let o = props.o;
    const [selectedOfferId, setSelectedOfferId] = useState<undefined|number>(undefined);
    const [inProgress, setInProgress] = useState(false);

    if(!o.bonusConfig) {
        return <div/>
    }
    let b = o.bonusConfig;


    return (
        <AccountCard>
            <div className={"row"}>
                {b.imageUrl && b.imageUrl.trim().length > 0 && (
                    <div className={"col-md-2 image"}>
                        <div className={"bonus-image"} style={{ backgroundImage : `url('${b.imageUrl}')`}}></div>
                    </div>
                )}
                <div className={"col-md-6 content"}>
                    <h4>
                        {o.bonusConfig.translations && <Translator defaultTranslation={o.bonusConfig.name} translations={o.bonusConfig.translations.map(t=>({lng : t.language, value : t.name})) as any} />}
                    </h4>
                    <div className={"text"}>
                        {o.bonusConfig.translations && <Translator defaultTranslation={o.bonusConfig.summary} translations={o.bonusConfig.translations.map(t=>({lng : t.language, value : t.summary})) as any} />}
                    </div>
                    <div className={"expires"}>
                        <i className={"material-icons"}>schedule</i> {t("bonus.expires")} {formatDate(props.o.expires)}
                    </div>
                    <div className={"bonus-details"}>
                        <a href="#" onClick={() => openTerms()} className={"popup-link"}>
                            <i className="material-icons">info</i>{t("bonus.terms.terms-link")}
                        </a>
                        { o.bonusConfig?.turnoverContributions?.contributions?.map(c => getIconFromProduct(c.product)).map((c) => {
                            return <i key={c.className} className={c.className}>{c.text}</i>
                        } )}
                    </div>
                </div>
                <div className="col-md-4 actions">
                    {(props.claimOfferStatus == RequestState.NONE || props.claimOfferStatus == RequestState.OK) && !inProgress &&
                    <button className={`btn btn-cta small`}  onClick={() => {
                        setSelectedOfferId(o?.id);
                        return props.claim(o?.id)
                    }}>{t("bonus.claim")}</button>
                    }
                    {(props.claimOfferStatus == RequestState.IN_PROGRESS || inProgress) && <button disabled={selectedOfferId !== props.o.id} className={`btn btn-cta small`}>{selectedOfferId === props.o.id  ? <ButtonSpinner width="1rem" height="1rem"/> : t("bonus.claim")}</button>}
                    <ConfirmButton className={"btn btn-secondary-popup small"}
                                   onConfirm={()=>{
                                       setInProgress(true);
                                       return getContainer().getUserBonusService().cancelBonusOffer(o.id).then(() => {
                                           // setInProgress(false);
                                           return props.fetchBonusInfo && props.fetchBonusInfo()
                                       })
                                   }
                                   }
                                   label={t("bonus.cancel-offer.button-label")}
                                   errorText={t("bonus.cancel-offer.error-text")}
                                   confirmText={t("bonus.cancel-offer.confirm-text")}
                                   confirmTitle={t("bonus.cancel-offer.confirm-header")}
                                   customCancelText={t("bonus.cancel-offer.custom-cancel-label")}
                    />
                </div>
            </div>
        </AccountCard>


    )
}

const mapStateToProps = (app : AppState, props : BonusOfferProps) => {
    if(!app.settings.settings || !app.settings.settings.currencies || !props.o) {
        return {};
    }
    if( !props.o.bonusConfig || !props.o.bonusConfig.monetaryConfig) {
        return {};
    }
    let currency = props.o.bonusConfig.monetaryConfig.currencyCode;
    return {
        currency : app.settings.settings.currencies.find( (c) => c.code == currency),
    }

}
export const BonusOfferComponent = connect(mapStateToProps)(BonusOfferImpl);
